export default __webpack_public_path__ + "assets/images/5e668d9be4f67e41f0f5c1d9adf1602d.svg";